import { Link } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { WordmarkLogo } from "./wordmark-logo";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/alliances", label: "Alliances" },
  { to: "/journeys", label: "Journeys" },
  { to: "/express", label: "Express" },
  { to: "/about", label: "About" },
] as const;

export function Wordmark() {
  return (
    <span role="img" aria-label="WeVang!" className="block h-8 w-[125px] md:h-10 md:w-[156px]">
      <WordmarkLogo className="block h-full w-full" />
    </span>
  );
}


export function SiteHeader({ overHero = false }: { overHero?: boolean }) {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const solid = scrolled || !overHero;
  const onDark = !solid && !open;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 ${
        solid ? "bg-background border-b border-border" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-5 md:px-12">
        <Link to="/" aria-label="WeVang! home" onClick={() => setOpen(false)}>
          <Wordmark />
        </Link>


        <nav className="hidden items-center gap-8 md:flex">
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              className={`text-xs font-medium uppercase tracking-[0.18em] hover:text-primary ${
                onDark ? "text-white/80" : "text-foreground/70"
              }`}
              activeProps={{ className: "text-primary" }}
              activeOptions={{ exact: item.to === "/" }}
            >
              {item.label}
            </Link>
          ))}
        </nav>

        <button
          type="button"
          className={`md:hidden ${
            onDark ? "text-white" : "text-foreground"
          }`}
          aria-label={open ? "Close menu" : "Open menu"}
          onClick={() => setOpen((v) => !v)}
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>


      {open && (
        <nav className="border-t border-border bg-background px-6 pb-8 pt-4 md:hidden">
          {NAV.map((item) => (
            <Link
              key={item.to}
              to={item.to}
              onClick={() => setOpen(false)}
              className="block border-b border-border/60 py-4 font-display text-2xl font-black uppercase tracking-tight text-foreground"
              activeProps={{ className: "text-primary" }}
              activeOptions={{ exact: item.to === "/" }}
            >
              {item.label}
            </Link>
          ))}
        </nav>
      )}
    </header>
  );
}
